import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    TableCell,
    TableRow,
    Theme,
    Tooltip,
    Typography
} from "@mui/material";
import {
    PaginationObj,
    TableHeaderData
} from "../types";
import {
    DownloadIcon,
    InfoIconOutlined,
    MutualFundsActiveIcon
} from "../../../assets/SvgIcons";
import CustomTable from "../common/customTable";
import { ReportListEcas } from "../../../redux-store/types/eCasDownloads";
import dayjs from "dayjs";

const tableHeaderData: TableHeaderData[] = [
    {
        id: 'id',
        label: 'S NO',
        align: 'left',
        isSortable: false,
    },
    {
        id: 'requestDate',
        label: 'REQUEST DATE & TIME',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'fromDate',
        label: 'FROM DATE',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'toDate',
        label: 'TO DATE',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'action',
        label: 'ACTION',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'actionButton',
        label: '',
        align: 'center',
        isSortable: false,
    },
]

const statusColorMap: { [key: string]: string } = {
    pending: "warning.500",
    completed: "success.500",
    failed: "error.500"
}


function DataTable({
    tableBodyData,
    handleStatementDownload,
    isDownloading,
    selectedIdForDownload,
    handleMFActionIconClick
}: {
    tableBodyData: Array<ReportListEcas>;
    handleStatementDownload: (selectedReqId: string) => void;
    isDownloading: boolean;
    selectedIdForDownload: string | null;
    handleMFActionIconClick: (selectedReqId: string) => void
}): JSX.Element {

    return (
        <>
            {
                tableBodyData.map((obj: ReportListEcas, index: number) => {
                    return (
                        <TableRow
                            key={`${obj.id}-${index}`}
                            sx={(theme: Theme) => ({
                                height: "4.5em",
                                '& td': {
                                    padding: "5px",
                                    height: "4.5em",
                                    borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                },
                                '& td:first-of-type': {
                                    paddingLeft: "0px"
                                },
                            })}
                        >
                            <TableCell align="left">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    {obj.id}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    {obj?.requestDate ? dayjs(obj?.requestDate).format('DD MMM, YYYY hh:mmA') : "-"}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    {obj.fromDate}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    {obj.toDate}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: statusColorMap[`${obj?.status ?? ""}`.toLowerCase()] ?? theme.palette.text.primary,
                                    })}
                                >
                                    {(`${obj?.status ?? ""}`.toLowerCase() === "pending") && (
                                        "PENDING"
                                    )}
                                    {(`${obj?.status ?? ""}`.toLowerCase() === "completed") && (
                                        "SUCCESS"
                                    )}
                                    {(`${obj?.status ?? ""}`.toLowerCase() === "failed") && (
                                        "FAIL"
                                    )}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                {(`${obj?.status ?? ""}`.toLowerCase() === "completed") && (
                                    // (isDownloading && selectedIdForDownload === obj.reqId) ? (
                                    //     <CircularProgress
                                    //         color="info"
                                    //         size={20}
                                    //     />
                                    // ) : (
                                    //     <IconButton
                                    //         sx={{ cursor: 'pointer' }}
                                    //         onClick={() => handleStatementDownload(obj.reqId)}
                                    //     >
                                    //         <DownloadIcon />
                                    //     </IconButton>
                                    // )

                                    (isDownloading && selectedIdForDownload === obj.reqId) ? (
                                        <CircularProgress
                                            color="info"
                                            size={20}
                                        />
                                    ) : (
                                        <Button
                                            onClick={() => handleMFActionIconClick(obj.reqId)}
                                            sx={(theme: Theme) => ({
                                                ...theme.typography.body_500,
                                                color: theme.palette.primary[500],
                                                padding: "5px"
                                            })}
                                            disabled={isDownloading}
                                        >
                                            Go
                                        </Button>
                                        // <Tooltip
                                        //     slotProps={{
                                        //         tooltip: {
                                        //             sx: {
                                        //                 margin: "0px !important",
                                        //                 backgroundColor: "transparent",
                                        //             }
                                        //         }
                                        //     }}
                                        //     title={
                                        //         <Box sx={(theme: Theme) => ({
                                        //             borderRadius: '10px',
                                        //             backgroundColor: theme.palette.customColors.cinder,
                                        //             padding: '10px',
                                        //             display: 'flex',
                                        //             flexDirection: 'column',
                                        //             rowGap: '10px',
                                        //         })}>
                                        //             <Typography variant='subtitle_600'>
                                        //                 Go to Detailed Portfolio Holdings
                                        //             </Typography>
                                        //         </Box>
                                        //     }
                                        // >
                                        //     <IconButton onClick={() => handleMFActionIconClick(obj.reqId)}>
                                        //         <MutualFundsActiveIcon />
                                        //     </IconButton>
                                        // </Tooltip>
                                    )
                                )}
                                {/* {(`${obj?.status ?? ""}`.toLowerCase() === "failed") && (
                                    <Tooltip
                                        slotProps={{
                                            tooltip: {
                                                sx: {
                                                    margin: "0px !important",
                                                    backgroundColor: "transparent",
                                                }
                                            }
                                        }}
                                        title={
                                            <Box sx={(theme: Theme) => ({
                                                borderRadius: '10px',
                                                backgroundColor: theme.palette.customColors.cinder,
                                                padding: '10px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                rowGap: '10px',
                                            })}>
                                                <Typography variant='subtitle_600'>
                                                    Failed to generate Report. Please contact Admin.
                                                </Typography>
                                            </Box>
                                        }
                                    >
                                        <IconButton>
                                            <InfoIconOutlined />
                                        </IconButton>
                                    </Tooltip>
                                )} */}
                            </TableCell>
                        </TableRow >
                    )
                })
            }
        </>
    )
}

export function MobileResponsiveEcasBody({
  data,
  handleStatementDownload,
  isDownloading,
  selectedIdForDownload,
  handleMFActionIconClick
}: {
  data: Array<ReportListEcas>;
  handleStatementDownload: (selectedReqId: string) => void;
  isDownloading: boolean;
  selectedIdForDownload: string | null;
  handleMFActionIconClick: (selectedReqId: string) => void;
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {data.map((obj: ReportListEcas, index: number) => (
        <Box
          key={`${obj.id}-${index}`}
          sx={(theme: Theme) => ({
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "12px",
            padding: "12px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            boxShadow: theme.shadows[1],
          })}
        >
          {/* Top Row → SNO & Action */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography
              variant="body_600"
              sx={(theme: Theme) => ({
                color: theme.palette.text.primary,
              })}
            >
              {tableHeaderData.find(h => h.id === "id")?.label}: {obj.id}
            </Typography>

            {(`${obj?.status ?? ""}`.toLowerCase() === "completed") && (
              (isDownloading && selectedIdForDownload === obj.reqId) ? (
                <CircularProgress color="info" size={20} />
              ) : (
                <Button
                  onClick={() => handleMFActionIconClick(obj.reqId)}
                  sx={(theme: Theme) => ({
                    ...theme.typography.body_500,
                    color: theme.palette.primary[500],
                    padding: "4px 8px",
                    minWidth: "40px",
                  })}
                  disabled={isDownloading}
                >
                  Go
                </Button>
              )
            )}
          </Box>

          {/* Other fields */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {/* Request Date */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}
              >
                {tableHeaderData.find(h => h.id === "requestDate")?.label}
              </Typography>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({ color: theme.palette.text.primary,textAlign: "right" })}
              >
                {obj?.requestDate ? dayjs(obj?.requestDate).format("DD MMM, YYYY hh:mmA") : "-"}
              </Typography>
            </Box>

            {/* From Date */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}
              >
                {tableHeaderData.find(h => h.id === "fromDate")?.label}
              </Typography>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
              >
                {obj.fromDate}
              </Typography>
            </Box>

            {/* To Date */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}
              >
                {tableHeaderData.find(h => h.id === "toDate")?.label}
              </Typography>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
              >
                {obj.toDate}
              </Typography>
            </Box>

            {/* Status */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}
              >
                Status
              </Typography>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  color:
                    statusColorMap[`${obj?.status ?? ""}`.toLowerCase()] ??
                    theme.palette.text.primary,
                })}
              >
                {(`${obj?.status ?? ""}`.toLowerCase() === "pending" && "PENDING") ||
                  (`${obj?.status ?? ""}`.toLowerCase() === "completed" && "SUCCESS") ||
                  (`${obj?.status ?? ""}`.toLowerCase() === "failed" && "FAIL")}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}






export default function StmtTable({
    isLoading,
    tableData,
    tablePaginationObj,
    handleTableRowsPerPageChange,
    handleTablePageChange,
    handleStatementDownload,
    isDownloading,
    selectedIdForDownload,
    handleMFActionIconClick
}: {
    isLoading: boolean;
    tableData: Array<ReportListEcas>;
    tablePaginationObj: PaginationObj;
    handleTableRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleTablePageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
    handleStatementDownload: (selectedReqId: string) => void;
    isDownloading: boolean;
    selectedIdForDownload: string | null;
    handleMFActionIconClick: (selectedReqId: string) => void
}): JSX.Element {
    return (
        <CustomTable
            isLoading={isLoading}
            tableBody={
                <DataTable
                    tableBodyData={tableData}
                    handleStatementDownload={handleStatementDownload}
                    isDownloading={isDownloading}
                    selectedIdForDownload={selectedIdForDownload}
                    handleMFActionIconClick={handleMFActionIconClick}
                />
            }
            tableData={tableData}
            tableHeaderData={tableHeaderData}
            tableHeadRowCustomStyles={{
                '& th:first-of-type': {
                    paddingLeft: "0px"
                }
            }}
            tableBodyCustomStyles={{
                '& tr:last-child td': {
                    border: 0
                }
            }}
            loadingRowsNum={5}
            tableDataCount={tablePaginationObj.totalRows}
            rowsPerPage={tablePaginationObj.rowsPerPage}
            rowsPerPageOptions={[5, 10, 15, 20]}
            handleRowsPerPageChange={handleTableRowsPerPageChange}
            handlePageChange={handleTablePageChange}
            currentPage={tablePaginationObj.currentPage}

            manualResponsiveBody={true}
            hideResponsiveHeader={true}
            ManualResponsiveBodyComponent={
                <MobileResponsiveEcasBody
                    data={tableData}
                    handleStatementDownload={handleStatementDownload}
                    isDownloading={isDownloading}
                    selectedIdForDownload={selectedIdForDownload}
                    handleMFActionIconClick={handleMFActionIconClick}
                />
            }
        />
    )
}